import { useWalletRewardPointQuery } from '@capsicum/common';

export const useSsuBalance = () => {
	const { data: ssuBalance } = useWalletRewardPointQuery();

	return isNaN(Number(ssuBalance)) ? 0 : Number(ssuBalance);
};
